import { usePlatformUpdate } from '@reapitform/hooks'
import { IDocuments } from '@reapitform/dashboard-ui'

export interface ResendAgreementPayload {
  iDs: string[]
}

export const useResendAgreement = () => {
  const path: string = '/api/User/Document/Approve'

  const [resendAgreement, isLoading, returnData, isSuccess, isError] = usePlatformUpdate<
    ResendAgreementPayload,
    IDocuments
  >({
    path: path,
    method: 'PATCH',
    headers: {},
    errorMessage: 'Failed to resend the agreement',
    successMessage: 'Agreement successfully sent',
  })

  return { resendAgreement, returnData, isLoading, isSuccess, isError }
}
